import { DifficultyEnum } from '../Models/Game/GameModel';

export default [
    {
        type: DifficultyEnum.easy,
        globalTaskProbability: 20,
        bonusGenerateDelay: 10,
        scoreAddingPercent: 0,
    },
    {
        type: DifficultyEnum.medium,
        globalTaskProbability: 30,
        bonusGenerateDelay: 15,
        scoreAddingPercent: 100,
    },
    {
        type: DifficultyEnum.hard,
        globalTaskProbability: 50,
        bonusGenerateDelay: 15,
        scoreAddingPercent: 200,
    },
];
